import React from 'react';
import { useParams } from 'react-router-dom';
import { Bot } from 'lucide-react';

const AgentDetails: React.FC = () => {
  const { agentType } = useParams<{ agentType: string }>();

  return (
    <div className="space-y-6">
      <div className="text-center py-20">
        <Bot className="h-16 w-16 mx-auto text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">{agentType} Agent</h2>
        <p className="text-gray-600">Agent details page coming soon...</p>
      </div>
    </div>
  );
};

export default AgentDetails;
